// Pure helpers for the chat page's task list and panel (spec 2026-09-17-agent-tasks §4.9).
export const TASK_POLL_MS = 30000;

const CHIP = { active: 'st-ok', paused: 'st-warn', cancelled: 'st-neutral' };

export function taskChip(task) {
  return CHIP[task && task.status] || 'st-neutral';
}

export function taskActions(task) {
  if (!task || task.status === 'cancelled') return [];
  return task.status === 'paused' ? ['resume', 'cancel'] : ['pause', 'cancel'];
}

export function nextFireText(task, lang, now = Date.now()) {
  const he = lang === 'he';
  if (task && task.status === 'paused') return he ? 'מושהה' : 'paused';
  if (!task || task.status !== 'active' || !task.next_fire_at) return he ? 'לא מתוזמן' : 'not scheduled';
  const mins = Math.round((Date.parse(task.next_fire_at) - now) / 60000);
  if (mins <= 0) return he ? 'עכשיו' : 'due now';
  if (mins < 60) return he ? `בעוד ${mins} דק׳` : `in ${mins}m`;
  const hrs = Math.round(mins / 60);
  if (hrs < 48) return he ? `בעוד ${hrs} שע׳` : `in ${hrs}h`;
  const days = Math.round(hrs / 24);
  return he ? `בעוד ${days} ימים` : `in ${days}d`;
}

export function runCost(usd) {
  return usd == null ? '—' : `$${Number(usd).toFixed(2)}`;
}

// The company the admin is impersonating, read from the tenant token the chat already
// uses. Scoping only -- the server authorises every call with the admin token (review M9).
export function tenantIdOfToken(token) {
  try {
    const part = String(token || '').split('.')[1];
    const claims = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/')));
    return Number.isInteger(claims.tenant_id) ? claims.tenant_id : null;
  } catch (_) {
    return null;
  }
}

// The query params for a scoped agent-tasks list, or null when the token names no company.
// call() drops a null/undefined param before building the query string, and the route's
// `tenant_id` is optional -- so passing tenantIdOfToken's raw result straight through would
// turn a malformed token into a silent request for EVERY tenant's tasks (review F3). null
// here is the caller's signal to show an error instead of calling the API unscoped.
export function scopedTaskParams(token) {
  const tenantId = tenantIdOfToken(token);
  return tenantId == null ? null : { tenant_id: tenantId };
}

export function mandateActions(status) {
  return status === 'proposed' ? ['approve', 'reject'] : [];
}
export function mandateLabel(m) {
  if (!m || m.status === 'none') return 'No mandate';
  const label = {proposed: 'Proposed', approved: 'Approved', rejected: 'Rejected'}[m.status] || m.status;
  return `${label} for ${(m.recipients || []).length} recipients`;
}
export function mailLine(m) {
  return `${m.direction === 'out' ? 'to ' + (m.to || []).join(', ') : 'from ' + (m.from || '—')} - ${m.status}`;
}
// Mandate v2 (agent seats PR 3, design handoff 2026-10-02 §4): what a mandate
// carries beyond recipients and purpose -- a whole-domain recipient, the
// interfaces it may load, an expiry. Each is present only when its key is, as
// ask_render.mandate_v2_lines words the mail and Telegram asks, so a v1
// mandate's panel reads as before. Structure, not text: the panel isolates
// each interface name, because several LTR names joined into one RTL line
// reorder against each other. `any` picks the approval prompt that names them.
export function mandateExtras(m) {
  const domains = ((m && m.recipients) || []).some((r) => r.startsWith('@'));
  const writes = (m && m.writes) || [];
  const expiresAt = (m && m.expires_at) || null;
  return { domains, writes, expiresAt, any: domains || writes.length > 0 || expiresAt !== null };
}
